import { lazy } from 'react';
// import BusinessProtected from './BusinessProtected';
// import Protected from './Protected';
// import SlideTransition from '../components/animation/transition/SlideTransition';
const BusinessLayout = lazy(() => import('../components/Layouts/BusinessLayout'));
const Protected = lazy(() => import('./Protected'));
const BusinessProtected = lazy(() => import('./BusinessProtected'));

const Settings = lazy(() => import('../components/business/businessSettings/Settings'));
const BusinessDashboard = lazy(() => import('../components/business/BusinessDashboard'));
const BusinessProfilePage = lazy(() => import('../components/business/BusinessProfilePage'));
const ListingsManagementPage = lazy(() => import('../components/business/ListingsManagementPage'));
const BillingPayment = lazy(() => import('../components/main/payment/BillingPayment'));
const SlideTransition = lazy(() => import('../components/animation/transition/SlideTransition'));

export const businessRoutes = [
  {
    path: '/business-dashboard',
    element: <BusinessLayout />,
    children: [
      {
        path: 'settings',
        element: (
          <BusinessProtected>
            <SlideTransition>
              <Settings />
            </SlideTransition>
          </BusinessProtected>
        ),
      },
      {
        path: 'manage-listings',
        element: (
          <BusinessProtected>
            <SlideTransition>
              <ListingsManagementPage />
            </SlideTransition>
          </BusinessProtected>
        ),
      },
      {
        path: 'dashboard',
        element: (
          <BusinessProtected>
            <SlideTransition direction="ltr">
              <BusinessDashboard />
            </SlideTransition>
          </BusinessProtected>
        ),
      },
      {
        path: 'profile',
        element: (
          <BusinessProtected>
            <SlideTransition>
              <BusinessProfilePage />
            </SlideTransition>
          </BusinessProtected>
        ),
      },
      {
        path: 'billing-payment',
        element: (
          <Protected>
            <BillingPayment isBusiness={true} />
          </Protected>
        ),
      },
    ],
  },
];
